import { type WebhookSamplePayload } from '@littlebird/sdk';

export type ParsedSamplePayload =
  | { ok: true; sample: WebhookSamplePayload | null }
  | { ok: false; error: string };

/** Reads the text a user pasted as an endpoint's sample payload; blank text means no sample. */
export const parseSamplePayload = (text: string): ParsedSamplePayload => {
  if (!text.trim()) return { ok: true, sample: null };
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    return { ok: false, error: 'This isn’t valid JSON.' };
  }
  if (Array.isArray(parsed)) return { ok: true, sample: parsed };
  if (typeof parsed === 'object' && parsed !== null) {
    return { ok: true, sample: parsed as Record<string, unknown> };
  }
  return { ok: false, error: 'Paste a JSON object or array.' };
};
